module.exports = __webpack_public_path__ + "media/images/flags/nl-d79426a3e38254c7420143c4202b3ab9.png";